import {changeFields, clearContext, cancelChanges} from 'client/common/store/reducers/context';

import {getSurvey} from 'client/common/store/selectors/survey';

import {put, select, takeEvery} from 'redux-saga/effects';

export function* cancelContextChanges() {
    const {context = {}} = yield select(getSurvey);

    yield put(clearContext());
    yield put(changeFields(context));
}

export default function* router() {
    yield takeEvery(cancelChanges, cancelContextChanges);
}
